module.exports = __webpack_public_path__ + "static/persimmon-bf6cf5ab0d1ef55ef5cf47f27ee7c61b.svg";